import browse from './browse.vue';
import create from './create.vue';
import edit from './edit.vue';
import read from './read.vue';

export default { browse, create, edit, read };
